import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import htmlParser from 'react-html-parser'
import { useTable } from 'react-table'
import { getFastenersTotal } from '../../../utils/fastener'

import '../../../../../../../globals/scss/components/tableview-virtualized.scss'
import '../../../../../styles/scss/components/_print.scss'

const JobTable = ({ columns, data }) => {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useTable({
    columns,
    data,
  })

  const fastenersTotal = useMemo(() => {
    const total = getFastenersTotal(data)

    return total
  }, [data])

  return (
    <div className="nonScrollable hs__nonScrollable jobTable">
      <table {...getTableProps()}>
        <thead>
          {
            // Loop over the header rows
            headerGroups.map((headerGroup) => {
              const { key, ...headerGroupProps } = headerGroup.getHeaderGroupProps()
              return (
                // Apply the header row props
                <tr key={key} {...headerGroupProps}>
                  {
                    // Loop over the headers in each row
                    headerGroup.headers.map((column) => {
                      const { key, ...headerProps } = column.getHeaderProps()
                      return (
                        // Apply the header cell props
                        <th key={key} {...headerProps}>
                          {column.render('Header')}
                        </th>
                      )
                    })
                  }
                </tr>
              )
            })
          }
        </thead>
        {/* Apply the table body props */}
        <tbody {...getTableBodyProps()}>
          {
            // Loop over the table rows
            rows.map((row) => {
              // Prepare the row for display
              prepareRow(row)
              const { key, ...rowProps } = row.getRowProps()
              return (
                // Apply the row props
                <tr key={key} {...rowProps}>
                  {
                    // Loop over the rows cells
                    row.cells.map((cell) => {
                      // Apply the cell props
                      const { key, ...cellProps } = cell.getCellProps()
                      return (
                        <td key={key} {...cellProps}>
                          {
                            // Render the cell contents
                            cell.render('Cell')
                          }
                        </td>
                      )
                    })
                  }
                </tr>
              )
            })
          }
          <tr className="pseudoFooter p-0">
            <td className="-bold" colSpan="4"></td>
            <td colSpan="10" className="p-0">
              <div className="hs__subTotalHead">Fastener Totals</div>
              <div className="hs__subTotalData" style={{ whiteSpace: 'nowrap' }}>
                {htmlParser(fastenersTotal.join('<br />'))}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}

JobTable.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.object).isRequired,
  data: PropTypes.arrayOf(PropTypes.any).isRequired,
  pdfFormat: PropTypes.bool,
}

JobTable.defaultProps = {
  loading: false,
  getHeaderProps: () => ({}),
  getColumnProps: () => ({}),
  getRowProps: () => ({}),
  getCellProps: () => ({}),
}

export default JobTable
